import { Component, OnInit, inject } from '@angular/core';
import {TexteAdministrable} from '../../../class/api/TexteAdministrable';
import {api} from '../../../api/api-dictionnary';
import {HydraService} from '../../../core/services/hydra.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {UtilisateurSignature} from '../../../class/api/UtilisateurSignature';
import {LocalStorage} from 'ngx-webstorage';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from '../../../pipes/safeHtml.pipe';

@Component({
    selector: 'app-modal-charte-deontologique',
    templateUrl: './modal-charte-deontologique.component.html',
    styleUrls: ['./modal-charte-deontologique.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, FormsModule, MatCheckbox, MatButton, MatDialogClose, DatePipe, TranslateModule, SafeHtmlPipe]
})
export class ModalCharteDeontologiqueComponent implements OnInit {
    private hydraService = inject(HydraService);
    dialogRef = inject<MatDialogRef<ModalCharteDeontologiqueComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);
    auth = inject(AuthentificationService);

    charte: TexteAdministrable = null;
    public texte: string = null;
    //public documentChartDeontologieChexbox : boolean = false;
    public hideChartejunks = false;
    @LocalStorage() public dateShort; // FR de base


    public documentChartDeontologie: UtilisateurSignature = null;
    public documentChartDeontologieChexbox = false;

    constructor() {
        const data = this.data;

        if(data != false){
            this.documentChartDeontologie = this.data
                .documentChartDeontologie as UtilisateurSignature;
            this.documentChartDeontologieChexbox = this.data
                .documentChartDeontologieChexbox as boolean;
        }
    }

    ngOnInit() {
        this.getCharte();
    }

    public sign() {
        this.dialogRef.close(true);
    }

    public getCharte() {
        this.hydraService
            .getById(api.TexteAdministrables + '/document_charte_deontologie')
            .subscribe((res: TexteAdministrable) => {
                if (res) {
                    this.charte = res;
                }
                let locale = '';
                res.translations.map(item => {
                    if (item.locale == this.auth.userConnected.locale) {
                        locale = item.locale;
                        this.texte = item.texte;
                    }
                });

                return this.texte;
            });
    }

    charteValider(documentChartDeontologieChexbox) {
        if (this.data !== undefined && this.data !== '') {
            this.hideChartejunks = true;
            this.documentChartDeontologieChexbox = documentChartDeontologieChexbox;

            const charteIsChecked = true;
            //return charteIsChecked;
        }
    }

}
